(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["XMarkdown"] = factory(require("react"));
	else
		root["XMarkdown"] = factory(root["React"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__868__) {
return 